import { SelectOption, SelectOptionsCollection } from 'shared/models/SelectOption';
import { ECoworkingOfferType } from 'shared/repositories/coworking/entities/api/V1BookCoworkingRequestSchema';

export const coworkingOfferTypeSelectOptions: SelectOptionsCollection<ECoworkingOfferType> = [
  new SelectOption('Отдельный офис', ECoworkingOfferType.Office),
  new SelectOption('Закреплённое рабочее место', ECoworkingOfferType.FixedWorkplace),
  new SelectOption('Незакреплённое рабочее место', ECoworkingOfferType.FlexibleWorkplace),
];
